import { render, staticRenderFns } from "./XgPayPsw.vue?vue&type=template&id=e81f6316&scoped=true&"
import script from "./XgPayPsw.vue?vue&type=script&lang=js&"
export * from "./XgPayPsw.vue?vue&type=script&lang=js&"
import style0 from "./XgPayPsw.vue?vue&type=style&index=0&id=e81f6316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81f6316",
  null
  
)

export default component.exports